module.exports = __webpack_public_path__ + "static/img/img_denglu.cc7c290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/img_denglu.png
// module id = +szY
// module chunks = 1